var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeedbackResponseRate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.001,
    height: 24,
    viewBox: "0 0 24.001 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "auto-reply",
    d: "M10,18a8.047,8.047,0,0,0,.069,1H7.775L3.3,21.669a2.12,2.12,0,0,1-2.162.08A2.145,2.145,0,0,1,0,19.855V5A5.007,5.007,0,0,1,5,0H17a5.006,5.006,0,0,1,5,5v6.082A7.986,7.986,0,0,0,10,18Zm14,0a6,6,0,1,1-6-6A6,6,0,0,1,24,18Zm-2,0a1,1,0,0,0-1-1H18V15.879a.877.877,0,0,0-1.5-.622l-1.5,1.5a1.759,1.759,0,0,0,0,2.485l1.5,1.5A.877.877,0,0,0,18,20.12V19h3a1,1,0,0,0,1-1Z",
    transform: "translate(0.001)",
    fill: "#136ad0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackResponseRate);
export default __webpack_public_path__ + "static/media/feedback-response-rate.b8cca42bf584e439188b087501bb161b.svg";
export { ForwardRef as ReactComponent };